<template>
  <div>

    <div class="hit-form-group" v-if="$store.getters.user.username">
      <div v-bind:title="$t('message.personalData')">

          <ckeditor :editor="editor" v-model="txt" :config="editorConfig"></ckeditor>

      </div>
    </div>

    <div class="hit-form-group" v-if="!$store.getters.user.username && txt">

          <div v-html="txt"/>

      </div>
    </div>

  </div>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'

export default{
  props: {text: String, onSave: Function},

  watch: {
    txt (val) { this.onSave(val) }
  },

  data () {
    return {
      txt: this.text,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList' ],
        language: 'de'
      }
    }
  }
}

</script>
